/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { generateConnectedClusterAutoOpsUrl } from '@modules/autoops-lib/util'

import type { AnyCluster, CCMService } from './types'

export function getLinkedServiceUrl(service: CCMService, cluster: AnyCluster): string | undefined {
  switch (service) {
    case 'auto_ops':
      if (!cluster.services.auto_ops.enabled) {
        return undefined
      }

      if (!cluster.services.auto_ops.config) {
        // Config is only present after the autoops service makes a patch
        // request via the admin api and sets it, so may be (ephemerally)
        // undefined.
        return undefined
      }

      return generateConnectedClusterAutoOpsUrl({
        region: cluster.services.auto_ops.config.region_id,
        organizationId: cluster.metadata.organization_id,
        ccmResourceId: cluster.id,
      })
    default:
      return undefined
  }
}

export function connectedClustersURL() {
  return '/connected-clusters'
}

export function connectedClusterURL(ccmClusterID: string): string {
  return `${connectedClustersURL()}/${ccmClusterID}`
}
